"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InteractionWithTimelineEngagement;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var _InteractionRecord = _interopRequireDefault(require("customer-data-objects/interaction/InteractionRecord"));

var _EngagementMediator = require("crm_ui/components/profile/interactions/common/EngagementMediator");

var _Interactions = require("customer-data-communicator/schema/communicator/interaction/Interactions");

var _TimelineActions = _interopRequireDefault(require("crm_ui/timeline/data/actions/TimelineActions"));

var _EngagementTypesType = _interopRequireDefault(require("crm_ui/engagements/EngagementTypesType"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _EmailAPIErrorTypes = require("crm_data/constants/EmailAPIErrorTypes");

var _EmailAPIErrorMessages = require("crm_data/email/EmailAPIErrorMessages");

/*
  Adds Timeline Engagement support to an interaction.  Creates engagements from interactions and adds the engagement to the
  Timeline.
*/
var propTypes = {
  descriptor: _propTypes.default.instanceOf(_InteractionDescriptorRecord.default).isRequired,
  engagementType: _EngagementTypesType.default,
  objectType: _ProfileObjectTypesType.default.isRequired,
  ownerId: _propTypes.default.number.isRequired,
  teamId: _propTypes.default.number,
  subject: _propTypes.default.object,
  subjectId: _propTypes.default.string.isRequired,
  onCreateEngagement: _propTypes.default.func.isRequired,
  onReset: _propTypes.default.func.isRequired,
  handleCloseCommunicator: _propTypes.default.func
};
var defaultProps = {
  handleCloseCommunicator: _emptyFunction.default
};

function InteractionWithTimelineEngagement(InteractionComponent) {
  var InteractionWithTimelineEngagementComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    (0, _inherits2.default)(InteractionWithTimelineEngagementComponent, _PureComponent);

    function InteractionWithTimelineEngagementComponent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, InteractionWithTimelineEngagementComponent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithTimelineEngagementComponent).call(this, props));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      _this.state = {
        interaction: new _InteractionRecord.default(),
        isSaving: false
      };
      return _this;
    }

    (0, _createClass2.default)(InteractionWithTimelineEngagementComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this._isMounted = true;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._isMounted = false;
      }
    }, {
      key: "handleInitInteractionRecord",
      value: function handleInitInteractionRecord(interactionRecord) {
        var _this$props = this.props,
            engagementType = _this$props.descriptor.engagementType,
            ownerId = _this$props.ownerId,
            teamId = _this$props.teamId;
        return (0, _Interactions.initInteractionRecord)(interactionRecord, engagementType, ownerId, teamId);
      }
    }, {
      key: "handleCreateEngagementRecord",
      value: function handleCreateEngagementRecord(interactionRecord) {
        return (0, _Interactions.toEngagementRecord)(interactionRecord);
      }
    }, {
      key: "handleCancel",
      value: function handleCancel() {
        this.props.onReset();
        this.props.handleCloseCommunicator();
      }
    }, {
      key: "handlePostProcessOnly",
      value: function handlePostProcessOnly(engagement) {
        var objectType = this.props.objectType;
        var engagementType = engagement.getIn(['engagement', 'type']);
        (0, _EngagementMediator.processEngagement)(engagement);
        this.props.onCreateEngagement(engagement);

        _TimelineActions.default.enableFavoriteEvent(objectType, engagementType);

        this.handleCancel();
      }
    }, {
      key: "handleGetNotesOnlyDeferredSave",
      value: function handleGetNotesOnlyDeferredSave(engagementRecord, engagement, options) {
        var id = engagement.get('id');
        var body = engagementRecord.getIn(['metadata', 'body']);
        var disposition = engagementRecord.getIn(['metadata', 'disposition']);
        var isCallTranscriptEligible = options.isCallTranscriptEligible,
            initialCallAssociations = options.initialCallAssociations;
        var updates = {
          metadata: {
            body: body,
            disposition: disposition,
            isCallTranscriptEligible: isCallTranscriptEligible
          },
          engagement: {
            activityType: options.activityType
          },
          attachments: engagementRecord.attachments
        };
        engagementRecord = engagementRecord.set('engagement', engagement);
        return (0, _EngagementMediator.updateEngagementFieldsAndAssociations)(id, engagementRecord, updates, initialCallAssociations);
      }
    }, {
      key: "handleSave",
      value: function handleSave(interactionRecord, engagement) {
        var _this2 = this;

        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _this$props2 = this.props,
            objectType = _this$props2.objectType,
            subjectId = _this$props2.subjectId;
        var deferredSave = null;
        this.setState({
          isSaving: true
        }); // emails

        if (options.postProcessOnly) {
          if (!engagement) {
            // Engagements are null for never-log emails
            var message = (0, _EmailAPIErrorMessages.getEmailApiErrorLangKey)(_EmailAPIErrorTypes.BLACKLISTED_EMAIL_IN_RECIPIENTS_NO_EMAIL);
            (0, _Alerts.addError)(message);
            this.handleCancel();
            return null;
          }

          this.handlePostProcessOnly(engagement);
          return null;
        }

        interactionRecord = this.handleInitInteractionRecord(interactionRecord);
        var engagementRecord = this.handleCreateEngagementRecord(interactionRecord);
        var engagementType = engagementRecord.getIn(['engagement', 'type']); // calls

        if (engagement && options.notesOnly) {
          deferredSave = this.handleGetNotesOnlyDeferredSave(engagementRecord, engagement, options);
        } else {
          // notes, logged activities, tasks, meetings
          options.subjectId = +subjectId;
          deferredSave = (0, _EngagementMediator.createEngagement)(engagementRecord, objectType, interactionRecord, (0, _immutable.Map)(options));
        }

        deferredSave.then(function (createdEngagement) {
          _TimelineActions.default.enableFavoriteEvent(objectType, engagementType);

          _this2.props.onCreateEngagement(createdEngagement, options.initialBETServiceAssociations, options.initialBETPortalAssociations);

          _this2.props.onReset();
        }).catch(function () {
          _this2.setState({
            isSaving: false
          });
        }).done();
        this.props.handleCloseCommunicator();
        return deferredSave;
      }
    }, {
      key: "render",
      value: function render() {
        var interaction = this.state.interaction;
        return _react.default.createElement(InteractionComponent, (0, _extends2.default)({
          interaction: interaction,
          onCancel: this.handleCancel,
          onCompleteSave: _emptyFunction.default,
          onSave: this.handleSave
        }, this.props));
      }
    }]);
    return InteractionWithTimelineEngagementComponent;
  }(_PureComponent2.default);

  InteractionWithTimelineEngagementComponent.propTypes = propTypes;
  InteractionWithTimelineEngagementComponent.defaultProps = defaultProps;
  return InteractionWithTimelineEngagementComponent;
}

module.exports = exports.default;